module.exports = __webpack_public_path__ + "static/media/banner_new_pago_rapido.3fc3972f.png";